<section class="services-area pt-100 pb-70 bg-f1f8fb">
  <div class="container">
    @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
      <div class="section-title">
        <h2>{{sectionTitleContent.title}}</h2>
      </div>
    }

    <div class="row">
      @for (solutionsBoxContent of singleSolutionsBox; track solutionsBoxContent) {
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-solutions-box">
            <div class="icon">
              <img [src]="solutionsBoxContent.icon" [alt]="solutionsBoxContent.title + ' service icon'">
            </div>
            <h3><a routerLink="/{{solutionsBoxContent.link}}">{{solutionsBoxContent.title}}</a></h3>
            <p>{{solutionsBoxContent.paragraphText}}</p>
            <a routerLink="/{{solutionsBoxContent.link}}" class="view-details-btn">{{solutionsBoxContent.linkText}}</a>
          </div>
        </div>
      }
    </div>
  </div>
</section>